// my projects : led car project, nicks led sign, WalTer, SafeTrek, this website

import React from "react";
import "./projects.css";
import ImageCarousel from "../projects/ImageCarousel";
import SafeTrek from "../../images/SafeTrek.JPG";
import OnAir from "../../images/On Air Schematic.jpg"
import Walter from "../../images/WalTer.JPG"
import MyWebsite from "../../images/My Website.png"
import LED from "../../images/LED Car Schematic.jpeg"
import WatchHer from "../../images/WatchHer.jpg"
import AMPLab from "../../images/AMPLabCompSchematic.png"
import Audio from "../../images/Home Audio System.jpeg"
import Audio2 from "../../images/Audio2.jpeg"
import Audio3 from "../../images/Audio3.jpeg"
import AMPLabVideo from "../../videos/Power Failure Detection System.mp4"

const ampLabItems = [
  { type: "image", src: AMPLab },
  { type: "video", src: AMPLabVideo },
];

const audioItems = [
  { type: "image", src: Audio },
  { type: "image", src: Audio2 },
  { type: "image", src: Audio3 },
];

const Projects = () => {
  return (
     <section className="projects-section">
      <h2 className="projects-title">My Projects</h2>
      <div className="projects">
             {/* project -1 : Home Audio System */}
      <div className="project-card">
        <ImageCarousel items={audioItems} alt="Home Audio System" />

        <div className="project-content">
          <h3 className="title">Home Audio System</h3>

          <div className="project-divider" />

          <p className="summary">
            Designed and validated a multi-stage audio system integrating a 3-band equalizer, MOSFET Class-D amplifier, and Butterworth RLC filter.
          </p>

          <div className="project-tags">
            <span>Analog Circuit Design</span>
            <span>LTspice</span>
            <span>Active Filters</span>
            <span>Class-D Amplifier</span>
            <span>Arduino</span>
            <span>PWM</span>
          </div>

          {<div className="project-buttons">
            <a href="https://youtube.com/shorts/P-tPEAIqyoE?is=b-7F6J5eMiurPixr" target="_blank" rel="noopener noreferrer">Video</a>
          </div>}

          
        </div>
      </div>
      {/* project 0 : AMP Lab Competition Project */}
      <div className="project-card">
        <ImageCarousel items={ampLabItems} alt="Power Supply Failure Detection System" />

        <div className="project-content">
          <h3 className="title">Power Supply Failure Detection System</h3>

          <div className="project-divider" />

          <p className="summary">
            Designed and built an analog circuit that monitors an input signal and detects when a voltage leaves its acceptable operating range. Indicates fault conditions using LEDs. 
          </p>

          <div className="project-tags">
            <span>Circuit Analysis</span>
            <span>Comparitor Op-Amp</span>
            <span>LTspice</span>
            <span>BJT Transistor</span>
            <span>Oscilloscope</span>
            <span>Circuit Building</span>
          </div>

          {/* <div className="project-buttons">
            <a href="#" target="_blank" rel="noopener noreferrer">Demo</a>
            <a href="#" target="_blank" rel="noopener noreferrer">GitHub</a>
          </div> */}

          
        </div>
      </div>
    
      {/* project 1 : Car project */}
      <div className="project-card">
        <img src={LED} alt="Automotive Electronics" className="photo" />

        <div className="project-content">
          <h3 className="title">Automotive Electronics Project</h3>

          <div className="project-divider" />

          <p className="summary">
            Installed a night-triggered LED interior lighting system using headlight signals and an automotive relay.
          </p>

          <div className="project-tags">
            <span>12v DC Systems</span>
            <span>Fuses</span>
            <span>Relay</span>
            <span>Vehicle Wiring</span>
          </div>

          {/* <div className="project-buttons">
            <a href="#" target="_blank" rel="noopener noreferrer">Demo</a>
            <a href="#" target="_blank" rel="noopener noreferrer">GitHub</a>
          </div> */}

          
        </div>
      </div>

      {/* Project 2: Led Sign */}
      <div className="project-card">
        <img src={OnAir} alt="Smart Home System" className="photo" />

        <div className="project-content">
          <h3 className="title">Wi-Fi ‘On Air’ LED Controller</h3>

          <div className="project-divider" />

          <p className="summary">
            Built a web-controlled ESP32 relay-based LED sign using embedded networking and relay control.
          </p>

          <div className="project-tags">
            <span>ESP32</span>
            <span>IoT</span>
            <span>Arduino</span>
            <span>Embedded Systems</span>
            <span>Wi-Fi</span>
            <span>GPIO</span>
            <span>HTTP</span>
            <span>Relay</span>

          </div>

          <div className="project-buttons">
            {/*<a href="#">Demo</a>*/}
            {/*<a href="#">GitHub</a>*/}
          </div>

          
        </div>
      </div>

      {/* Project 3: WatchHer */}
      <div className="project-card">
        <img src={WatchHer} alt="WatchHer" className="photo" />

        <div className="project-content">
          <h3 className="title">WatchHer</h3>

          <div className="project-divider" />

          <p className="summary">
            Built a Wear OS safety application that leverages smartwatch biometric sensors and stress detection to proactively identify potential danger and trigger alerts.
          </p>

          <div className="project-tags">
            <span>Andriod Studio</span>
            <span>WearOS</span>
            <span>Python</span>
            <span>Machine Learning</span>
            <span>RestAPI</span>
            <span>Kotlin</span>
          </div>

          <div className="project-buttons">
            
            <a href="https://github.com/rylieh31/WatchHer">GitHub</a>
            <a href="https://devpost.com/software/herwatch" target="_blank" rel="noopener noreferrer">Devpost</a>
          </div>

        
        </div>
      </div>

    {/* Project 4: SafeTrek */}
      <div className="project-card">
        <img src={SafeTrek} alt="Robotics Control Board" className="photo" />

        <div className="project-content">
          <h3 className="title">SafeTrek</h3>

          <div className="project-divider" />

          <p className="summary">
            2025 HackViolet award-winning web project that recommends travel suggestions based on user input to help women travel safely.
          </p>

          <div className="project-tags">
            <span>Node.js</span>
            <span>React</span>
            <span>Astro.js</span>
            <span>JavaScript</span>
            <span>TypeScript</span>
            <span>Tailwind CSS</span>
          </div>

          <div className="project-buttons">
            
            <a href="https://github.com/HackViolet2025Team/hackviolet2025team.github.io">GitHub</a>
            <a href="https://devpost.com/software/safetrek-s4elz5" target="_blank" rel="noopener noreferrer">Devpost</a>
          </div>

        
        </div>
      </div>


      {/* Project 5: WalTer */}
      <div className="project-card">
        <img src={Walter} alt="Robotics Control Board" className="photo" />

        <div className="project-content">
          <h3 className="title">WalTer</h3>

          <div className="project-divider" />

          <p className="summary">
            Custom autonomous personal inventory management robot developed for the Penn State University Biannual Hackathon.
          </p>

          <div className="project-tags">
            <span>Arduino Uno R4</span>
            <span>Raspberry Pi Zero 2</span>
            <span>Python</span>
            <span>C++</span>
            <span>React</span>
            <span>TypeScript</span>
          </div>

          <div className="project-buttons">
            {/*<a href="#">Demo</a>*/}
            <a href="https://github.com/honzikschenk/WalTer">GitHub</a>
            <a href="https://devpost.com/software/walter-your-everyday-inventory-companion" target="_blank" rel="noopener noreferrer">Devpost</a>

          </div>

        
        </div>
      </div>

      {/* Project 6: This Website */}
      <div className="project-card">
        <img src={MyWebsite} alt="Robotics Control Board" className="photo" />

        <div className="project-content">
          <h3 className="title">Personal Portfolio Website</h3>

          <div className="project-divider" />

          <p className="summary">
            My personal portfolio featuring my projects, skills, and experience, with a clean, modern tech-inspired design.
          </p>

          <div className="project-tags">
            <span>React</span>
            <span>JavaScript</span>
            <span>HTML/CSS</span>
          </div>

          <div className="project-buttons">
            <a href="https://ryliehorning.me">Demo</a>
            <a href="https://github.com/rylieh31/Personal-Website">GitHub</a>
          </div>

        
        </div>
      </div>
      </div>
    </section>
  );
};

export default Projects;